import { Injectable } from '@angular/core';

@Injectable()
export class WinterService {

  private winter: boolean;
  private marketdateEvasivedate: Date;

  constructor() {}

  isWinter(marketdateEvasivedate): boolean {
    this.marketdateEvasivedate = new Date(marketdateEvasivedate);
    if (this.marketdateEvasivedate.getMonth() + 1 >= 11 || this.marketdateEvasivedate.getMonth() + 1 < 4) {
      this.winter = true;
    } else {
      this.winter = false;
    }
    return this.winter;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/winter.service.ts